module.exports = __webpack_public_path__ + "static/media/mobile_capy_page_area03_img_en@2x.98aa2564.png";